<ng-template #snackbarTemplate>
  <div class="snack-bar">
    <span class="hd-icon-close snack-bar-close" (click)="dismiss()"></span>
    <div class="container">
      <span class="snack-bar-icon {{icon}}"></span>
      <div class="content">
        <span class="xsight-headline6 snackbar-header">{{title}}</span>
        <span class="xsight-body3 snackbar-message">{{message}}</span>
      </div>
    </div>
  </div>
</ng-template>